import { render, staticRenderFns } from "./transfer-detail.vue?vue&type=template&id=48e781e0&"
import script from "./transfer-detail.vue?vue&type=script&lang=js&"
export * from "./transfer-detail.vue?vue&type=script&lang=js&"
import style0 from "./transfer-detail.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports